<template>
  <div class="page page-service-work">
    <h3>Создание новой работы техобслуживания</h3>
    <div class="row">
      <div class="col-12">
        <label>Название</label>
        <input type="text" class="form-control" v-model="serviceWork.name" placeholder required />
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <label>Интервал обслуживания</label>
        <input type="text" class="form-control" v-model="serviceWork.interval" placeholder required />
      </div>
    </div>
    <hr class="mb-4" />
    <button class="btn btn-primary" @click="createServiceWork()">Создать</button>
    <router-link to="/service-works" class="btn btn-primary">Назад</router-link>
  </div>
</template>
<script>
import serviceWorksApi from '@/api/service-works'
import Swal from 'sweetalert2'
export default {
  name: 'CreateServiceWork',
  data () {
    return {
      isCreating: false,
      serviceWork: {
        name: '',
        interval: '',
        sort: ''
      }
    }
  },
  methods: {
    createServiceWork () {
      if (this.isCreating) {
        return
      }
      this.isCreating = true
      serviceWorksApi.createItem(this.serviceWork)
        .then(work => {
          this.isCreating = false
          this.$router.push('/service-works')
        })
        .catch(text => {
          this.isCreating = false
          Swal.fire({
            icon: 'error',
            title: 'Ошибка',
            html: text.message
          })
        })
    }
  }
}
</script>
<style lang="scss" scoped>
  .btn, .btn-primary {
    float: right;
    margin-left: 0.7rem;
  }
</style>
